import { Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

const CenterDropdown = ({
  onSelectCenter,
  isEditMode = false,
  selectedCenterId,
  error,
  centers
}) => {
  const [selectedCenter, setSelectedCenter] = useState(selectedCenterId || "");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedCenter(value);

    const centerObj = centers.find(
      (center) => center.center_id.toString() === value
    );

    if (onSelectCenter) {
      onSelectCenter(centerObj);
    }
  };
  useEffect(() => {
    if (selectedCenterId) {
      setSelectedCenter(selectedCenterId);
    }
  }, [selectedCenterId]);

  return (
    <Form.Group className="mb-3 position-relative">
      <FormattedMessage id="select_branch" />
      <Form.Select
        value={selectedCenter}
        onChange={handleChange}
        disabled={isEditMode}
        isInvalid={error}
      >
        <option value="">-- Select Branch --</option>
        {centers?.map((center) => (
          <option key={center.center_id} value={center.center_id}>
            {center.name}
          </option>
        ))}
      </Form.Select>
      <Form.Control.Feedback className="px-3" type="invalid">
        <FormattedMessage id="error.center_id" />
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default CenterDropdown;
